import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "hero-image",
  style: {"margin-bottom":"30px"}
}
const _hoisted_4 = ["src"]


export default /*@__PURE__*/_defineComponent({
  __name: 'MainHeader',
  props: {
    isDark: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: _ctx.isDark ? 'slide-dark' : 'slide-light',
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("img", {
          key: _ctx.isDark ? 'dark-logo' : 'light-logo',
          src: _ctx.isDark ? require('@/assets/image/test.png') : require('@/assets/image/3333.svg'),
          alt: "fiftyfifty",
          class: "fifty-img"
        }, null, 8, _hoisted_2))
      ]),
      _: 1
    }, 8, ["name"]),
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_Transition, {
        name: _ctx.isDark ? 'slide-dark' : 'slide-light',
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("img", {
            key: _ctx.isDark ? 'dark-hero' : 'light-hero',
            src: _ctx.isDark ? require('@/assets/image/darkmidnight.png') : require('../../assets/image/tofifty.png'),
            class: "hero-image1",
            alt: "FIFTY FIFTY Members",
            style: {"border-radius":"20px","width":"60%"}
          }, null, 8, _hoisted_4))
        ]),
        _: 1
      }, 8, ["name"])
    ])
  ]))
}
}

})